import { Link, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useFlag } from '@unleash/proxy-client-react';
import { useEffect, useState } from 'react';
import { Banner } from '../components/Banner';

const BANNER_LOCAL_STORAGE_KEY = 'staticFinchConnectDisabledBanner';

const dates = ['2025-08-15', '2025-08-22'];
const endDate = '2025-08-29';
const getNextDueDate = (date: string) => {
  const nextDate = dates.find((d) => dayjs(d).isAfter(dayjs(date), 'day'));

  return nextDate ? dayjs(nextDate) : null;
};

export const StaticFinchConnectDisabledBanner = () => {
  // will keep the old FF for now, since this will be removed soon
  const featureFlagEnabled = useFlag('useSessionIdMigrationBanner');
  const [show, setShow] = useState(false);

  const onClose = () => {
    setShow(false);

    localStorage.setItem(
      BANNER_LOCAL_STORAGE_KEY,
      dayjs().format('YYYY-MM-DD'),
    );
  };

  useEffect(() => {
    const today = dayjs().format('YYYY-MM-DD');

    if (!featureFlagEnabled || today === endDate) {
      setShow(false);
      return;
    }

    const bannerKey = localStorage.getItem(BANNER_LOCAL_STORAGE_KEY);
    if (!bannerKey) {
      setShow(true);
      return;
    }

    const nextDueDate = getNextDueDate(bannerKey);

    // If there's no next due date (stored date is after all reminder dates),
    // we should stop showing the banner permanently
    if (!nextDueDate) {
      setShow(false);
      return;
    }

    const todayIsPastOrSameAsNextDueDate =
      dayjs().isSame(nextDueDate) || dayjs().isAfter(nextDueDate);

    const canShow = todayIsPastOrSameAsNextDueDate;

    setShow(canShow);
  }, [featureFlagEnabled]);

  if (!show) return null;

  return (
    <Banner type="info" onClose={onClose}>
      <Text>
        Reminder! Static Finch Connect URLs will be officially disabled on
        August 29, 2025, after which Session IDs will be required to use Finch
        Connect.
      </Text>
    </Banner>
  );
};
